export const elfCharacters = [
  {
    id: "elf-001",
    name: "朱焰",
    category: "炽色精灵",
    categorySlug: "chise-jingling",
    title: "烈焰之心的守护者",
    description: "朱焰是炽色精灵族的领袖，她的羽翼燃烧着永不熄灭的热情之火。每当她振翅飞翔，天空中便留下一道绚丽的霞光。",
    imageUrl: "https://readdy.ai/api/search-image?query=Magical%20fantasy%20elf%20character%20with%20glowing%20wings%20in%20a%20luminous%20enchanted%20forest%2C%20warm%20ethereal%20atmosphere%2C%20soft%20sparkling%20particles%2C%20dreamy%20fantasy%20art%20style%2C%20rich%20colorful%20details%2C%20whimsical%20and%20elegant%20design%2C%20painterly%20illustration%2C%20magical%20ambient%20lighting%2C%20delicate%20translucent%20wings%2C%20enchanting%20fairy%20tale%20mood&width=600&height=400&seq=elf-zhuyan&orientation=landscape",
    colorClass: "from-orange-400/20 to-red-500/30",
    articleSlug: "zhuyan-chise-licheng",
  },
  {
    id: "elf-002",
    name: "翠微",
    category: "森林精灵",
    categorySlug: "senlin-jingling",
    title: "万木之灵的吟唱者",
    description: "翠微能与每一片叶子对话，她的歌声能让枯萎的花朵重新绽放，让荒芜的土地焕发生机。",
    imageUrl: "https://readdy.ai/api/search-image?query=Magical%20fantasy%20elf%20character%20with%20glowing%20wings%20in%20a%20luminous%20enchanted%20forest%2C%20warm%20ethereal%20atmosphere%2C%20soft%20sparkling%20particles%2C%20dreamy%20fantasy%20art%20style%2C%20rich%20colorful%20details%2C%20whimsical%20and%20elegant%20design%2C%20painterly%20illustration%2C%20magical%20ambient%20lighting%2C%20delicate%20translucent%20wings%2C%20enchanting%20fairy%20tale%20mood&width=600&height=400&seq=elf-cuiwei&orientation=landscape",
    colorClass: "from-emerald-400/20 to-green-600/30",
    articleSlug: "cuiwei-senlin-miyu",
  },
  {
    id: "elf-003",
    name: "碧漪",
    category: "海底精灵",
    categorySlug: "haidi-jingling",
    title: "深海秘境的探索者",
    description: "碧漪游弋于珊瑚礁与深海峡谷之间，她收集海底最珍贵的色彩，将它们编织成流光溢彩的画卷。",
    imageUrl: "https://readdy.ai/api/search-image?query=Magical%20fantasy%20elf%20character%20with%20glowing%20wings%20in%20a%20luminous%20enchanted%20forest%2C%20warm%20ethereal%20atmosphere%2C%20soft%20sparkling%20particles%2C%20dreamy%20fantasy%20art%20style%2C%20rich%20colorful%20details%2C%20whimsical%20and%20elegant%20design%2C%20painterly%20illustration%2C%20magical%20ambient%20lighting%2C%20delicate%20translucent%20wings%2C%20enchanting%20fairy%20tale%20mood&width=600&height=400&seq=elf-biyi&orientation=landscape",
    colorClass: "from-cyan-400/20 to-teal-500/30",
    articleSlug: "biyi-shenhai-qiyu",
  },
  {
    id: "elf-004",
    name: "星烁",
    category: "星光精灵",
    categorySlug: "xingguang-jingling",
    title: "银河之光的收集者",
    description: "星烁在每一个夜晚穿梭于星辰之间，将散落的星光收集起来，编织成指引迷途者的明灯。",
    imageUrl: "https://readdy.ai/api/search-image?query=Magical%20fantasy%20elf%20character%20with%20glowing%20wings%20in%20a%20luminous%20enchanted%20forest%2C%20warm%20ethereal%20atmosphere%2C%20soft%20sparkling%20particles%2C%20dreamy%20fantasy%20art%20style%2C%20rich%20colorful%20details%2C%20whimsical%20and%20elegant%20design%2C%20painterly%20illustration%2C%20magical%20ambient%20lighting%2C%20delicate%20translucent%20wings%2C%20enchanting%20fairy%20tale%20mood&width=600&height=400&seq=elf-xingshuo&orientation=landscape",
    colorClass: "from-amber-300/20 to-yellow-500/30",
    articleSlug: "xingshuo-yinhe-zhiye",
  },
  {
    id: "elf-005",
    name: "夕颜",
    category: "黄昏精灵",
    categorySlug: "huanghun-jingling",
    title: "暮色之舞的编织者",
    description: "夕颜在黄昏时分翩翩起舞，她的舞步牵引着天边的云彩，将天空染成最温柔的渐变色。",
    imageUrl: "https://readdy.ai/api/search-image?query=Magical%20fantasy%20elf%20character%20with%20glowing%20wings%20in%20a%20luminous%20enchanted%20forest%2C%20warm%20ethereal%20atmosphere%2C%20soft%20sparkling%20particles%2C%20dreamy%20fantasy%20art%20style%2C%20rich%20colorful%20details%2C%20whimsical%20and%20elegant%20design%2C%20painterly%20illustration%2C%20magical%20ambient%20lighting%2C%20delicate%20translucent%20wings%2C%20enchanting%20fairy%20tale%20mood&width=600&height=400&seq=elf-xiyan&orientation=landscape",
    colorClass: "from-pink-400/20 to-rose-500/30",
    articleSlug: "xiyan-huaghund-wudao",
  },
  {
    id: "elf-006",
    name: "晶莹",
    category: "水晶精灵",
    categorySlug: "shuijing-jingling",
    title: "七彩晶石的守护者",
    description: "晶莹生活在水晶矿洞深处，她以纯净的心灵守护着每一颗水晶，让它们在光芒中绽放七彩华彩。",
    imageUrl: "https://readdy.ai/api/search-image?query=Magical%20fantasy%20elf%20character%20with%20glowing%20wings%20in%20a%20luminous%20enchanted%20forest%2C%20warm%20ethereal%20atmosphere%2C%20soft%20sparkling%20particles%2C%20dreamy%20fantasy%20art%20style%2C%20rich%20colorful%20details%2C%20whimsical%20and%20elegant%20design%2C%20painterly%20illustration%2C%20magical%20ambient%20lighting%2C%20delicate%20translucent%20wings%2C%20enchanting%20fairy%20tale%20mood&width=600&height=400&seq=elf-jingying&orientation=landscape",
    colorClass: "from-violet-300/20 to-fuchsia-400/30",
    articleSlug: "jingying-shuijing-mikuang",
  },
];